export default __webpack_public_path__ + "static/media/spring.0b5ed834.png";